import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0m-11.425.728 3.207 3.207 5.707-5.707-1.414-1.414-4.293 4.293-1.793-1.793z"
    }, null, -1)
  ]))]))
}
export default { render: render }